<template>
  <section class="">
    <div class="container thanks">
      <div class="text-center pt-5">
        <h1>
          <font-awesome-icon :icon="['far', 'heart']" style="color: #f68920" />
          ขอขอบคุณผู้บริจาคทุกท่าน
          <font-awesome-icon :icon="['far', 'heart']" style="color: #f68920" />
        </h1>
      </div>
      <p>
        มหาวิทยาลัยทักษิณขอขอบพระคุณเป็นอย่างสูงที่ได้ร่วมบริจาคมา ณ โอกาสนี้
        เราขอสัญญาว่าจะนำเงินบริจาคดังกล่าวไปใช้ให้เกิดประโยชน์ตามวัตถุประสงค์ของท่านต่อไป
      </p>
    </div>
    <div id="search" class="container pt-3">
      <div class="card">
        <div
          class="card-header d-sm-flex justify-content-between border-0 pb-0 card-header-divider"
        >
          <div class="row">
            <div class="col-md-12 col-sm-6">
              <div class="input-group mb-3">
                <input
                  type="text"
                  name="keyword"
                  class="keyword form-control"
                  placeholder="ค้นหาชื่อ/ ชื่อบริษัท"
                  aria-label="ชื่อ นามสกุล"
                  v-model="searchTerm"
                  @keyup.enter="submitSearch"
                />
                <button
                  class="btn btn-find btn-info"
                  type="button"
                  id="button-addon2"
                  @click.prevent="submitSearch"
                >
                  <font-awesome-icon :icon="['fas', 'search']" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row g-2 py-3">
        <div v-for="item in paginatedData" :key="item.DONATEID" class="col-md-4 col-sm-4">
          <div class="border rounded-3 p-3 donate-info">
            <div class="donor-name">
              {{ replaceSpecialCharacters(item.PREFIX) }}{{ item.NAME }}
              {{ replaceSpecialCharacters(item.SURNAME) }}
            </div>
            <div class="d-flex justify-content-between">
              <div>
                จำนวน
                <span class="donate-amount">{{ formatPrice(item.AMOUNT) }}</span> บาท
              </div>
              <div class="group-name">{{ item.GROUP_NAME }}</div>
            </div>
          </div>
        </div>
      </div>
      <div id="pagination">
        <div class="d-flex justify-content-end py-2">
          <div class="btn-group d-block" role="group" aria-label="button pagination">
            <button
              type="button"
              class="btn btn-outline-primary mt-3"
              :disabled="currentPage === 1"
              @click="goToPage(currentPage - 1)"
            >
              &laquo;
            </button>
            <button
              v-for="(page, index) in paginationRange"
              :key="index"
              type="button"
              class="btn btn-outline-primary mt-3"
              :disabled="currentPage === page || page === '...'"
              @click="page !== '...' && goToPage(page)"
            >
              {{ page }}
            </button>
            <button
              type="button"
              class="btn btn-outline-primary mt-3"
              :disabled="currentPage === totalPages"
              @click="goToPage(currentPage + 1)"
            >
              &raquo;
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { formatPrice, replaceSpecialCharacters } from '../components/scripts/utillities';
import { useDonors } from '../components/scripts/useDonors';

const { donors, getDonorInfo, searchDonors: searchDonorsAPI } = useDonors();

const searchTerm = ref('');
const itemsPerPage = 24;
const currentPage = ref(1);

const paginatedData = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  return donors.value.slice(startIndex, endIndex);
});

const totalPages = computed(() => {
  return Math.ceil(donors.value.length / itemsPerPage);
});

const paginationRange = computed(() => {
  const current = currentPage.value;
  const last = totalPages.value;
  const delta = 1; // จำนวนหน้าที่แสดงก่อนและหลังหน้าปัจจุบัน (แสดงทั้งหมด 3 หน้า)
  const left = current - delta;
  const right = current + delta + 1;
  const range = [];
  const rangeWithDots = [];
  let l;

  for (let i = 1; i <= last; i += 1) {
    if (i === 1 || i === last || (i >= left && i < right)) {
      range.push(i);
    }
  }

  for (const i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(i);
    l = i;
  }

  return rangeWithDots;
});

const submitSearch = () => {
  if (searchTerm.value) {
    searchDonorsAPI(searchTerm.value);
  }
};

const goToPage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};

watch(searchTerm, (newValue) => {
  if (newValue === '') {
    getDonorInfo();
  }
});

onMounted(() => {
  getDonorInfo();
});
</script>

<style scoped>
.donate-info {
  font-size: 0.9rem;
}
.donor-name {
  font-weight: bold;
}
.campaign-title {
  font-weight: 400;
}
.donate-amount {
  font-weight: bold;
  color: #e02f2f;
}
.group-name {
  font-weight: 400;
}
p {
  text-indent: 40px;
  padding-left: 0.5rem;
}
.thanks {
  min-height: 200px;
  width: 100%;
  background-image: url('../assets/images/thanks/thankyou.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  padding: 0;
}
</style>